<template>
  <div>
    <v-toolbar
      color="theme_primary"
      dark
      extension-height="36"
      height="36"
      flat
      app
    >
      <v-toolbar-side-icon @click="drawerToggle()"
        ><v-icon>{{ drawerIcon() }}</v-icon></v-toolbar-side-icon
      >
      <v-layout align-center>
        <v-icon small>public</v-icon>
        <v-breadcrumbs
          :items="[
            {
              exact: false,
              text: 'Market Overview',
              disabled: true,
              to: '/market',
            },
          ]"
          dark
        >
          <template v-slot:divider>
            <v-icon>chevron_right</v-icon>
          </template>
        </v-breadcrumbs>
        <v-spacer></v-spacer>
        <headerProfile />
      </v-layout>

      <template v-slot:extension>
        <v-tabs
          v-model="tab"
          left
          color="transparent"
          slider-color="primary"
          height="36"
        >
          <v-tab
            active-class="active-tab primary--text"
            href="#offers"
            v-if="currentUserCan('see', 'offers')"
          >
            <v-icon small>flight_takeoff</v-icon>
            <span class="font-weight-bold pl-2">Offers</span>
          </v-tab>
          <v-tab
            active-class="active-tab primary--text"
            href="#demands"
            v-if="currentUserCan('see', 'demands')"
          >
            <v-icon small>flight_land</v-icon>
            <span class="font-weight-bold pl-2">Demands</span>
          </v-tab>
          <v-tab
            active-class="active-tab primary--text"
            href="#opportunities"
            v-if="currentUserCan('see', 'opportunities')"
          >
            <v-icon small>search</v-icon>
            <span class="font-weight-bold pl-2">Opportunities</span>
          </v-tab>
          <v-tab
            active-class="active-tab primary--text"
            to="/companies"
            v-if="currentUserCan('see', 'companies')"
          >
            <v-icon small>store</v-icon>
            <span class="font-weight-bold pl-2">Companies</span>
          </v-tab>
        </v-tabs>
      </template>
    </v-toolbar>
    <v-tabs-items v-model="tab">
      <v-tab-item value="offers" lazy v-if="currentUserCan('see', 'offers')">
        <v-flex class="px-4 pt-2">
          <offers />
        </v-flex>
      </v-tab-item>
      <v-tab-item value="demands" lazy v-if="currentUserCan('see', 'demands')">
        <v-flex class="px-4 pt-2">
          <demands />
        </v-flex>
      </v-tab-item>
      <v-tab-item
        value="opportunities"
        lazy
        v-if="currentUserCan('see', 'opportunities')"
      >
        <v-flex class="px-4 pt-2">
          <opportunities />
        </v-flex>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import offers from "../components/offersDemands/offers";
import demands from "../components/offersDemands/demands";
import opportunities from "../components/offersDemands/opportunities";
import headerProfile from "../components/shared/headerProfile";

export default {
  components: {
    offers,
    demands,
    opportunities,
    headerProfile,
  },
  data() {
    return {
      tab: this.$route.query.tab ? this.$route.query.tab : "offers",
    };
  },
  watch: {
    "$route.query.tab": function () {
      this.tab = this.$route.query.tab ? this.$route.query.tab : "offers";
    },
  },
};
</script>
